export interface Product {
  id: number;
  name: string;
  specs: string[];
  description: string;
  video: string;
}

export const productsData: Product[] = [
  {
    id: 1,
    name: "Shampoo para Barba",
    specs: [
      "150mL",
      "Sem parabenos",
      "Uso diário",
      "Limpeza profunda",
      "Fragrância amadeirada",
    ],
    description:
      "Shampoo desenvolvido especialmente para barbas que merecem respeito. Limpa profundamente sem ressecar, mantendo os fios fortes, alinhados e com aparência saudável. Fórmula profissional de barbearia para quem leva o rosto a sério.",
    video: "",
  },
  {
    id: 2,
    name: "Condicionador para Barba",
    specs: [
      "150mL",
      "Textura leve",
      "Desembaraço fácil",
      "Maciez e hidratação",
      "Fragrância amadeirada suave",
    ],
    description:
      "Condicionador que hidrata e amacia a barba sem deixá-la pesada. Facilita o penteado e mantém os fios sob controle. Cuidado de respeito para quem não abre mão da aparência firme e bem tratada.",
    video: "",
  },
  {
    id: 3,
    name: "Balm para Barba",
    specs: [
      "110mL",
      "Fixação média",
      "Hidratação intensa",
      "Acabamento natural",
      "Toque seco",
    ],
    description:
      "Balm modelador que hidrata, dá forma e estilo à barba. Toque seco, controle e acabamento natural. Para o homem que não aceita menos que o melhor — barba forte, presença marcante.",
    video: "",
  },
  {
    id: 4,
    name: "Balm Premium para Barbas Densas",
    specs: [
      "150mL",
      "Nutrição profunda",
      "Controle total",
      "Textura firme",
      "Ação anti-frizz",
    ],
    description:
      "Balm premium criado para barbas densas e fios mais espessos. Proporciona nutrição intensa, controle e definição. Mantém o volume sob medida e o estilo no ponto. Um cuidado robusto, digno de quem carrega presença.",
    video: "",
  },
  {
    id: 5,
    name: "Óleo Pós Barba",
    specs: [
      "30mL",
      "Absorção rápida",
      "Não oleoso",
      "Fragrância discreta",
      "Nutrição completa",
    ],
    description:
      "Óleo pós-barba de absorção rápida que nutre a pele e os fios sem deixar oleosidade. Cuidado profissional de barbearia, sem frescura. Só o essencial, só o melhor.",
    video: "",
  },
];
